var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/Node/BimNode.ts";
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
export var isBimNode = function isBimNode(node) {
  return isBimModelNode(node) || isBimCategoryNode(node) || isBimFamilyNode(node) || isBimStandardSizeNode(node) || isBimElementNode(node);
};
export var isBimModelNode = function isBimModelNode(node) {
  return node.type === 'BimModelNode';
};
export var isBimModelLoadedNode = function isBimModelLoadedNode(node) {
  return node.type === 'BimModelNode' && node.status === 'ImportCompleted';
};
export var isBimModelNotLoadedNode = function isBimModelNotLoadedNode(node) {
  return node.type === 'BimModelNode' && node.status !== 'ImportCompleted';
};
export var isBimCategoryNode = function isBimCategoryNode(node) {
  return node.type === 'BimCategoryNode';
};
export var isBimFamilyNode = function isBimFamilyNode(node) {
  return node.type === 'BimFamilyNode';
};
export var isBimStandardSizeNode = function isBimStandardSizeNode(node) {
  return node.type === 'BimStandardSizeNode';
};
export var isBimElementNode = function isBimElementNode(node) {
  return node.type === 'BimElementNode';
};